import { css, keyframes } from 'styled-components';

const fadeInKeyframes = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

/**
 * Fades an element in from 0 to full opacity, e.g. for content that pops in/replaces other
 * content without its own enter transition. Defaults match the common "quick fade" case; pass a
 * duration/easing to override for a specific use (slower fade, `ease-in`, etc).
 */
export const fadeIn = (duration = '120ms', easing = 'ease-out') => css`
  animation: ${fadeInKeyframes} ${duration} ${easing};
`;
